module.exports = __webpack_public_path__ + "assets/img/plant.ab222b55.png";